import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import { defaultFixturePlayByPlayFlaggedEventsExportFieldNames } from "~pages/Reports/components/FixturePlayByPlayFlaggedEventDataTable/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportFixturePlayByPlayFlaggedEvents = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const { formatMessage } = useIntl();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/fixture-play-by-play-flagged-events/export`, {
        method: "POST",
        body: {
          fieldNames: fieldNames || defaultFixturePlayByPlayFlaggedEventsExportFieldNames,
        },
      }),
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
        notification.success({
          message: formatMessage({ id: "fixturePBPEvent.export.started" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
